// extracted by mini-css-extract-plugin
export default {"container":"Details_container__HvkWG","form":"Details_form__g2tJa"};